import { GzEasmVulnerableServersWebComponent } from './component/GzEasmVulnerableServersWebComponent';

export { GzEasmVulnerableServersWebComponent };
